import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import moneyFormat from '../functions/moneyFormat';

// renders summary totals rows under a table, label spans all columns except the last, value sits under the last column
const ProgramAdjustmentTotalsTable = ({ tableHeader = [], totals = [] }) => {
    const colCount = tableHeader.length;
    if (colCount === 0) {
        return null;
    }

    return (
        <Paper>
            <TableContainer>
                <Table size="small">
                    <TableBody>
                        {totals.map(el => (
                            <TableRow key={el.label} sx={{ backgroundColor: "#E6EDF1" }}>
                                <TableCell colSpan={Math.max(colCount - 1, 1)} sx={{ fontFamily: "Roboto medium", fontWeight: "bold" }}>
                                    {el.label}
                                </TableCell>
                                <TableCell align="right" sx={{ fontFamily: "Roboto medium" }}>
                                    {moneyFormat(el.value)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default ProgramAdjustmentTotalsTable;
